import axios from 'axios';
import logError from '~/common/utils/errorLogging.js';
import smoothscrollPolyfill from 'smoothscroll-polyfill';

import UrlParam from '~/common/utils/urlParam.js';
import { numberLockSessionStore } from '~/common/stores/domain/numberLockSession.js';
import deepGet from '~/common/utils/deepGet.js';
import { OFFER_SUITE_DEFAULT, UAP_LOGIN_ENABLED, PATH_PRODUCT_LOGIN_BASE_UAP_URL, PATH_PRODUCT_LOGIN } from '~/common/utils/consts.js';

// polyfill the scroll* (intoView, By, & To) api for the DOM
smoothscrollPolyfill.polyfill();

// log API errors
axios.interceptors.response.use(
    response => response,
    (err) => {
        // Invalid or expired NumberLockSessionId
        if (deepGet(err, ['reponse', 'data', 'Details', 0, 'ErrorCode']) === 5004) {
            // Set NLS error
            numberLockSessionStore.setNLSError(true);
        }
        logError(err);
        return Promise.reject(err);
    }
);

export const ghOfferSuite = () => { return UrlParam('ghos', 'alphaNumericOnly', '-'); };
export const ghPreselectedPlan = () => { return UrlParam('ghpp', 'alphaOnly', ' '); };
export const ghNoPlan = () => { return UrlParam('ghnp'); };
export const ghIsTransferNeeded = () => { return UrlParam('itn', 'alphaNumericOnly'); };
export const ghFreeTrialAge = () => { return UrlParam('ftage', 'alphaNumericOnly'); };
export const ghPromoCode = () => {
    // For ESC-169, mapping the try75expired to new PromoCode 'sbw2024annual'
    let promoCode = UrlParam('promocode', 'alphaNumericOnly') || UrlParam('ghpc', 'alphaNumericOnly');
    if (promoCode === 'try75expired') {
        promoCode = 'try75recycledflex';
    }
    return promoCode;
};
export const ghNumberModal = () => { return UrlParam('ghnm'); };
// passes interest on toll free
export const ghTollFreeIntent = () => { return UrlParam('ghtf', 'alphaOnly'); };
// passes interest on vanity number
export const ghCustomTollFreeIntent = () => { return UrlParam('ghvtf', 'alphaOnly'); };
// passes the city name
export const ghCity = () => { return UrlParam('ghcity', 'alphaOnly', ' '); };
// passes interest on local numbers
export const ghLocalNumberIntent = () => { return UrlParam('ghlocal', 'alphaOnly'); };
export const ghSearchTerm = () => { return UrlParam('ghsearch', 'alphaNumericOnly'); };
export const ghSearchPrefix = () => { return UrlParam('ghprefix'); };
export const ghCountry = () => { return UrlParam('ghcountry', 'alphaOnly'); };
export const ghState = () => { return UrlParam('ghstate', 'alphaOnly'); };
export const ghArea = () => { return UrlParam('gharea', 'numericOnly'); };
export const ghUi = () => { return UrlParam('ghui', 'alphaNumericOnly', '()-+ '); };
export const ghE164 = () => { return UrlParam('ghe164', 'alphaNumericOnly', '+'); };
export const ghTrialSelected = () => { return UrlParam('ghts', 'alphaOnly'); };
export const ghTrialFeatureDisabled = () => { return UrlParam('ghtfd', 'alphaOnly'); };
export const ghPreselectedNumberType = () => { return UrlParam('ghpsnt', 'alphaOnly', ' '); };
export const ghNls = () => { return UrlParam('ghnls', 'alphaNumericOnly', '-'); };
export const ghToken = () => { return UrlParam('convert', 'alphaNumericOnly', '='); };
// offer suite discount amount
export const ghOp = () => { return UrlParam('ghOp', 'numericOnly'); };
export const ghPreselectedAnnualTerm = () => { return UrlParam('ghanl', 'alphaOnly'); };
export const ghClassicCheckout = () => UrlParam('ghcc', 'alphaOnly');
export const ghRubyRep = () => UrlParam('rep', 'alphaOnly', ' -');
export const ghRubyEmail = () => UrlParam('rbemail', 'alphaNumericOnly', '@-_.');
export const ghRubyRepEmail = () => UrlParam('rbrepemail', 'alphaNumericOnly', '@-_.');
export const ghRubyCode = () => { return UrlParam('rbcode', 'numericOnly'); };
export const ghAnnualUpgradeToken = () => { return UrlParam('gatok', 'alphaNumericOnly', '='); };
// apps flyers params
export const appsFlyerDeviceType = () => { return UrlParam('deviceType', 'alphaOnly'); };
export const appsFlyerDeviceId = () => { return UrlParam('deviceID', 'alphaNumericOnly', '-'); };
// salesforce params
export const utmCampaign = () => { return UrlParam('utm_campaign', 'numericOnly'); };


// Offer Suite / Plans
export const defaultOfferSuiteId = () => { return ghOfferSuite() || OFFER_SUITE_DEFAULT; };

// Ruby reactivation param
export const ghRubyReactivation = () => { return UrlParam('IsReactivation', 'alphaOnly'); };

export const pathProductLogin = () => { return UAP_LOGIN_ENABLED ? PATH_PRODUCT_LOGIN_BASE_UAP_URL() : PATH_PRODUCT_LOGIN; };
